import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const PanelAlertIcon: React.FC<NormalIconProps> = (props) => (
	<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={props.className}>
		<g clipPath="url(#clip0_1383_6393)">
			<path
				opacity="0.15"
				d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
			/>
			<path d="M17.4199 9.96012V17.0179C17.4199 17.3885 17.2727 17.744 17.0106 18.0061C16.7485 18.2682 16.393 18.4154 16.0224 18.4154C15.6517 18.4154 15.2962 18.2682 15.0341 18.0061C14.772 17.744 14.6248 17.3885 14.6248 17.0179L14.6248 9.96012C14.6248 9.58946 14.772 9.23399 15.0341 8.97189C15.2962 8.7098 15.6517 8.56256 16.0224 8.56256C16.393 8.56256 16.7485 8.7098 17.0106 8.97189C17.2727 9.23399 17.4199 9.58946 17.4199 9.96012ZM17.4199 22.0871C17.4199 22.3635 17.338 22.6337 17.1844 22.8635C17.0308 23.0933 16.8126 23.2725 16.5572 23.3782C16.3018 23.484 16.0208 23.5117 15.7497 23.4578C15.4786 23.4038 15.2296 23.2707 15.0341 23.0753C14.8387 22.8798 14.7056 22.6308 14.6517 22.3597C14.5977 22.0886 14.6254 21.8076 14.7312 21.5522C14.837 21.2969 15.0161 21.0786 15.2459 20.925C15.4757 20.7715 15.7459 20.6895 16.0224 20.6895C16.393 20.6895 16.7485 20.8367 17.0106 21.0988C17.2727 21.3609 17.4199 21.7164 17.4199 22.0871Z" />
		</g>
		<defs>
			<clipPath id="clip0_1383_6393">
				<rect width="32" height="32" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
